import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import PreviewButton from '../PreviewButton';
import TaskInformation from '../TaskInformation';
import ValidationButton from '../ValidationButton';
import {getReparationMissionById} from "../../../store/action/claimManagement";
import { getTask ,completeTask } from '../../../store/action/taskAction';
import { getClaimDetails ,createPaymentRepair } from "../../../store/action/claim";
import { getOrganizationDetails } from '../../../store/action/party';
import { makeStyles } from '@material-ui/core/styles';
import {useNavigate, useParams} from "react-router-dom";
import { format } from "date-fns";
import ErrorsAlert from "../../../utils/errorsAlert";
import { handleInputChangePieces } from "../../../utils/InputChange";
import MaskedDecimalInput from "../../../utils/MaskedDecimalInput";
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    paper: {
        display: 'grid',
        gridTemplateRows: '0.5fr 1fr',
        gap: '20px',
        padding: '20px',
        borderRadius: '11px',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    previewBtn: {
        position: 'absolute',
        //background: 'rgb(243, 246, 249)',
        right: '20px',
    },
    mainContent: {
        width: '95%',
        display: 'flex',
        flexDirection: 'column',
    },
    firstPart: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr',
        gap: '35px',
    },
    secondPart: {
        display: 'block',
    },
    thirdPart: {
        display: 'grid',
        gridTemplateColumns: '70% 30%',
        marginTop : '2%', 
        marginBottom: '2%',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
    },
    tableHeader: {
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 700,
        textAlign: 'left',
        color: 'rgba(70, 78, 95, 1)',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
    },
    tableTh: {
        fontFamily: 'Poppins',
        fontSize: '12px',
        fontWeight: 600,
        color: 'rgba(181, 181, 195, 1)',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        textAlign: 'left',
        paddingLeft: '5px',
        paddingBottom: '12px',
        paddingTop: '12px',
    },
    tableRow: {
        padding: '0',
    },
    tableContent: {
        paddingLeft: '5px',
        textAlign: 'left',
        borderBottom: '1px solid rgba(231, 231, 231, 1)',
        paddingBottom: '9px',
        paddingTop: '12px',
    },
 
    card: {
        width: '100%',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: 0,
        },
        minHeight: '200px',
    },
    cardItem: {
        display: 'flex',
        justifyContent: 'space-between',
        color: 'rgba(128, 128, 143, 1)',
        fontFamily: 'Poppins',
        fontWeight: 500,
        fontSize: '13px',
        alignItems: 'center'
    },
    optionText: {
        padding: "5px",
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputContainer: {
        border: 'rgba(243, 246, 249, 1)',
        background: 'rgba(243, 246, 249, 1)',
        width: "70%",
        height: '36px',
        borderRadius: 4,
        marginBottom: "20px",
    },
    inputLabel: {
        color: 'rgba(70, 78, 95, 1)',
        fontWeight: 400,
        fontFamily: 'Poppins',
        fontSize: 12,
    },
    inputText: {
        border: 0,
        background: 'rgba(243, 246, 249, 1)',
        width: '145px',
        height: '28px',
        borderRadius: '4px',
        opacity: '1',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
}));

const SendRepairShopPayment = () => {
    const { taskId } = useParams();
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const username = localStorage.getItem('username');
    const taskReducer = useSelector((state) => state.taskReducer?.taskList?.find(task => task?.taskId === taskId));
    const [task, setTask] = useState(taskReducer);
    const [infoSinistre, setInfoSinistre] = useState(task?.businessKey) 
   const [isRequestInProgress, setIsRequestInProgress] = useState(false);
    const todayFormatted = format(new Date(), "yyyy-MM-dd"); 
    const [isTaskClaimed, setIsTaskClaimed] = useState(true);
    const [dataOfFacture, setDataOfFacture] = useState({
        invoiceNumber: '',
        dateOfInvoice: todayFormatted,
        hoursT1:  '',
        hoursT2:  '',
        paintHours:  '',
        partsAmount:'0.000'
    });
    const [dataRepair, setDataRepair] = useState({
        totalRepairAmountWOTax: "0.000",
        totalRepairAmountWTax: "0.000"
    });
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleClose = () => {
        setOpenErrorDialog(false);
        setErrors([]);
    };

    const fetchTask = async () => {
        try {
            const response = await getTask(taskId, username);
            setTask(response)
            setInfoSinistre(response?.businessKey)
        } catch (error) {
            console.error(`Error fetching task details: ${error.message}`);
        }
    };
    const validateInputs = () => {
        const validationErrors = [];

        if (!dataOfFacture.invoiceNumber || dataOfFacture.invoiceNumber.trim() === "") {
            validationErrors.push("Le numéro de facture est requis");
        }

        if (!dataOfFacture.dateOfInvoice) {
            validationErrors.push("La date de facture est requise");
        } 

        const partsAmount = parseFloat(dataOfFacture.partsAmount);
        if (isNaN(partsAmount) || partsAmount < 0) {
            validationErrors.push("Le montant des pièces ne peut pas être négatif");
        }

        if (dataOfFacture.hoursT1 === "" || isNaN(dataOfFacture.hoursT1)) {
            validationErrors.push("Le nombre d'heures T1 est requis");
        } else if (parseFloat(dataOfFacture.hoursT1) < 0) {
            validationErrors.push("Le nombre d'heures T1 ne peut pas être négatif");
        }

        if (dataOfFacture.hoursT2 === "" || isNaN(dataOfFacture.hoursT2)) {
            validationErrors.push("Le nombre d'heures T2 est requis");
        } else if (parseFloat(dataOfFacture.hoursT2) < 0) {
            validationErrors.push("Le nombre d'heures T2 ne peut pas être négatif");
        }

        if (dataOfFacture.paintHours === "" || isNaN(dataOfFacture.paintHours)) {
            validationErrors.push("Le nombre d'heures peinture est requis");
        } else if (parseFloat(dataOfFacture.paintHours) < 0) {
            validationErrors.push("Le nombre d'heures peinture ne peut pas être négatif");
        }

        if (dataRepair.totalRepairAmountWOTax === "" || isNaN(dataRepair.totalRepairAmountWOTax)) {
            validationErrors.push("Le montant total HT est requis");
        } else if (parseFloat(dataRepair.totalRepairAmountWOTax) < 0) {
            validationErrors.push("Le montant total HT ne peut pas être négatif");
        }

        if (dataRepair.totalRepairAmountWTax === "" || isNaN(dataRepair.totalRepairAmountWTax)) {
            validationErrors.push("Le montant total TTC est requis");
        } else if (parseFloat(dataRepair.totalRepairAmountWTax) < 0) {
            validationErrors.push("Le montant total TTC ne peut pas être négatif");
        }

        if (dataRepair.totalRepairAmountWOTax !== "" &&
            dataRepair.totalRepairAmountWTax !== "" &&
            parseFloat(dataRepair.totalRepairAmountWTax) < parseFloat(dataRepair.totalRepairAmountWOTax)) {
            validationErrors.push("Le montant TTC doit être supérieur ou égal au montant HT");
        }

        return validationErrors;
    };

    const ValidationAction = async () => {
        const validationErrors = validateInputs();

        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setOpenErrorDialog(true);
            return;
        }

        setIsRequestInProgress(true);
        try {

            const claim =  await dispatch(getClaimDetails(task?.businessKey ));
            const repairer =  await getReparationMissionById(task?.variables.repartionMissionId.value);
            const partyRepairer =  await getOrganizationDetails(repairer?.associatedRepairer);
             
            const paymentRepair = {
                totalAmountTcc: claim?.claimAmount,
                associatedClaim: task?.businessKey,
                associatedParty: task?.variables.customerPartyUid.value ,
                documents: [],
                garageCode: partyRepairer?.code,
                partsAmount: parseFloat(dataOfFacture.partsAmount),
                totalHours: dataOfFacture.hoursT1,
                hoursT1: dataOfFacture.hoursT1,
                hoursT2: dataOfFacture.hoursT2,
                paintHours: dataOfFacture.paintHours,
                hourlyRateT1: 30.000,
                hourlyRateT2: 35.000,
                totalRepairAmountWOTax: parseFloat(dataRepair.totalRepairAmountWOTax),
                totalRepairAmountWTax: parseFloat(dataRepair.totalRepairAmountWTax),
                starShareWODiscountWTax: 0,
                clientShareWTax: 0,
                discountRateOnParts: 0,
                discountRateOnLabor: 0,
                discountAmountWOTax: 0,
                discountAmountWTax: 0,
                totalRepairAmountWDiscount: 0,
                starShareWithDiscountWTax: 0,
                invoiceNumber: dataOfFacture.invoiceNumber,
                beneficiary: "",
                idNumber: "",
                dateOfInvoice: dataOfFacture.dateOfInvoice,
                issuedOn: todayFormatted,
                issuedAt: "",
                responsibility: "",
                opposingCompany: "",
                opposingCompanyPolicyNumber: "",
                opposingCompanyClaimNumber: "",
                opposingCompanyVehicle: "",
                repairer:task?.variables.designatedRepairer.value
            };
            console.log("paymentRepair : ", paymentRepair)
            const response = await dispatch(createPaymentRepair(paymentRepair));
            if (response) {
                await dispatch(completeTask(taskId, username, {}));
               navigate('/todo-list', { reload: true });
            } else {
                setErrors(["La création du paiement a échoué. Veuillez réessayer."]);
                setOpenErrorDialog(true);
            }
        } catch (error) {
            console.error("Validation error:", error);
            setErrors(["Erreur lors de la validation. Veuillez réessayer."]);
            setOpenErrorDialog(true);
        } finally {
            setIsRequestInProgress(false);
        }
    };

    const updatedataRepair = (name, value) => {
        setDataRepair(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const formatDateToInput = (date) => {
        return date.toISOString().split('T')[0];
    };
    const updateDataOfFacture = (event) => {
        const { name, value } = event.target;

        if (name === "dateOfInvoice") {
            // Handle date input
            const parsedDate = new Date(value);

            setDataOfFacture((prevState) => ({
                ...prevState,
                [name]: formatDateToInput(parsedDate),
            }));
        } else if (name === "invoiceNumber") {
            setDataOfFacture((prevState) => ({
                ...prevState,
                [name]: value.trim(),
            }));
        } else if (name === "hoursT1" || name === "hoursT2" || name === "paintHours") {
            // Handle number inputs
            const numericValue = value === '' ? '' : parseFloat(value);
            setDataOfFacture((prevState) => ({
                ...prevState,
                [name]: isNaN(numericValue) ? '' : numericValue
            }));
        } else {
            setDataOfFacture((prevState) => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    useEffect(() => {
       
        fetchTask();
    }, [dispatch, taskId, username]);

    const updateMaskedDataOfFacture = (name, value) => {
        setDataOfFacture(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    useEffect(() => {
        if (task?.assignee === username) {
            setIsTaskClaimed(false);
        } else {
            setIsTaskClaimed(true);
        }
    }, [task, username]);

    return (
        <div className={classes.root}>
            <div style={{display: 'flex'}}>
            <div className={classes.mainContent}>
                <TaskInformation taskId={taskId} onClaimStatusChange={setIsTaskClaimed} />
                <Paper className={classes.paper}>
                <div className={classes.firstPart} >
                        <table className={classes.table}>
                            <thead>
                            <tr className={classes.tableHeader}>
                                <th style={{paddingBottom: '20px'}}>Données Facture</th>
                            </tr>
                            <tr>
                                <th className={classes.tableTh}>N° Facture</th>
                                <th className={classes.tableTh}>Date facture</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className={classes.tableRow}>
                                <td className={classes.tableContent}>
                                    <input name="invoiceNumber" value={dataOfFacture.invoiceNumber} onChange={updateDataOfFacture} className={classes.inputText} disabled={isTaskClaimed}/> </td>
                                <td className={classes.tableContent}> 
                                    <input type='date' max={todayFormatted} name="dateOfInvoice" value={dataOfFacture.dateOfInvoice} onChange={updateDataOfFacture} className={classes.inputText} disabled={isTaskClaimed}/> </td>
                            </tr>
                            </tbody>
                        </table>

                        <table className={classes.table}>
                            <thead>
                            <tr className={classes.tableHeader}>
                                <th colSpan="4" style={{paddingBottom: '20px'}}>Détails facture</th>
                            </tr>
                            <tr>
                                <th className={classes.tableTh}>Montant pièces</th>
                                <th className={classes.tableTh}>Nombre d’heure T1</th>
                                <th className={classes.tableTh}>Nombre d’heure T2</th>
                                <th className={classes.tableTh}>Nombre d’heure peinture</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr className={classes.tableRow}>
                                <td className={classes.tableContent}>
                                    <MaskedDecimalInput
                                        name="partsAmount"
                                        value={dataOfFacture.partsAmount}
                                        onChange={(value) => updateMaskedDataOfFacture("partsAmount", value)}
                                        className={classes.inputText}
                                        disabled={isTaskClaimed}
                                    />
                                </td>
                                <td className={classes.tableContent}>
                                    <input step="any" min="0.00" onInput= {handleInputChangePieces} name="hoursT1" value={dataOfFacture.hoursT1} onChange={updateDataOfFacture} className={classes.inputText} disabled={isTaskClaimed}/> </td>
                                <td className={classes.tableContent}>
                                    <input step="any" min="0.00" onInput= {handleInputChangePieces} name="hoursT2" value={dataOfFacture.hoursT2} onChange={updateDataOfFacture} className={classes.inputText} disabled={isTaskClaimed}/> </td>
                                <td className={classes.tableContent}>
                                    <input step="any" min="0.00" onInput= {handleInputChangePieces} name="paintHours" value={dataOfFacture.paintHours} onChange={updateDataOfFacture} className={classes.inputText} disabled={isTaskClaimed}/> </td>
                            </tr>
                            </tbody>
                        </table>
                </div> 
                <div className={classes.thirdPart}>
                    <div className={classes.card}></div>
                        <div className={classes.card}>
                            <div className={classes.cardItem}><span>Tarif Horeire T1</span>
                                <span >30.000 TND</span>
                            </div>
                            <div className={classes.cardItem}><span>Tarif Horeire T2</span>
                                <span >35.000 TND</span>
                            </div>
                            <div className={classes.cardItem}><span>Total réparation HT</span>
                                <MaskedDecimalInput
                                    name="totalRepairAmountWOTax"
                                    value={dataRepair.totalRepairAmountWOTax}
                                    onChange={(value) => updatedataRepair("totalRepairAmountWOTax", value)}
                                    className={classes.inputText}
                                    disabled={isTaskClaimed}
                                    style={{textAlign: 'right'}}
                                />
                            </div>
                             
                            <div className={classes.cardItem} >
                                <span style={{color: "rgba(60, 101, 86, 1)" , fontFamily: 'Poppins',fontSize: '13px',fontWeight: 700,}}>Total réparation TTC</span>
                                <MaskedDecimalInput
                                    name="totalRepairAmountWTax"
                                    value={dataRepair.totalRepairAmountWTax}
                                    onChange={(value) => updatedataRepair("totalRepairAmountWTax", value)}
                                    className={classes.inputText}
                                    disabled={isTaskClaimed}
                                    style={{textAlign: 'right'}}
                                />
                            </div>
                        </div>
                    </div>
                </Paper>
                {isRequestInProgress && (
                <div
                    style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",  // Center vertically
                    }}
                >
                    <div
                    style={{
                        background: "#fff",
                        padding: "20px",
                        borderRadius: "8px",
                        textAlign: "center",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        display: "flex",           // Use flexbox
                        flexDirection: "column",   // Stack the loader and text vertically
                        justifyContent: "center",  // Vertically center content inside the box
                        alignItems: "center",      // Horizontally center content inside the box
                    }}
                    >
                    <div className="spinner" style={{ marginBottom: "10px" }}></div>  {/* Optional margin between loader and text */}
                    <p style={{ fontFamily: "Poppins", fontSize: "16px", margin: 0 }}>
                        Veuillez patienter...
                    </p>
                    </div>
                </div>
            )}
            </div>
            <PreviewButton claimData={infoSinistre}  />
        </div>
            <ValidationButton taskId={taskId} handleValidation={() => isTaskClaimed ? null : ValidationAction()} />
            <ErrorsAlert
                open={openErrorDialog}
                errors={errors}
                handleClose={handleClose}
            />
        </div>
    );
};

export default SendRepairShopPayment;
